export default __webpack_public_path__ + "273632c3935a8720c1674340c82da76c.png";